import { Gavel } from 'lucide-react';

import type { AdminAuction } from '@nucleus-commerce/api-client/admin';

export function LotThumb({ lot, size = 40 }: { lot: AdminAuction['lot']; size?: number }) {
  return lot.imageUrl ? (
    <img
      src={lot.imageUrl}
      alt=""
      width={size}
      height={size}
      className="bg-muted shrink-0 rounded-md border object-cover"
      style={{ width: size, height: size }}
    />
  ) : (
    <span
      aria-hidden
      className="bg-muted text-muted-foreground flex shrink-0 items-center justify-center rounded-md border"
      style={{ width: size, height: size }}
    >
      <Gavel className="size-4" />
    </span>
  );
}
